import { reverseGeocode } from '../libs/mapLib';

const useStopNameGeocoder = ({setReverseGeocoding = () => {}}) => { 
    return async (stop) => {
        if (!stop.lat || !stop.lon) {
            return;
        }

        try {
            setReverseGeocoding(true);
            const data = await reverseGeocode(stop);
            
            if (data?.postcode) {
                stop.postcode = data.postcode;
            }
            if (data?.suburb || data?.town || data?.city) {
                stop.suburb = data.suburb || data.town || data.city;
            }
            if (!stop.stopName?.length && data?.address_line1) {
                stop.stopName = data.address_line1.trim();
            }

            return stop;
        } catch (error) {
            console.error('Error geocoding stop', error);
            throw error;
        } finally {
            setReverseGeocoding(false);
        }
    };
};

export default useStopNameGeocoder; 